import i18n from "../../resources/I18n";
import { DsdModale } from "../DSD/DsdModale";
import { INavigationParcours, obtenirNavigationUrl } from "../../util/Navigation";
import { useCybermetrieAMCContext } from "../utils/CybermetrieAMCContext";
import { CybermetriesAMC } from "../../util/CybermetrieAMC";

interface IModaleAnnulerProps {
  modaleAnnulerOuvert: boolean;
  onClickModaleAnnulerFermer: Function;
  cookieParcoursAssurance: INavigationParcours;
  parcours: string;
  estEmprunteurPrimaire: boolean;
  estNouvelleMarge: boolean;
}

function obtenirTexteModaleAnnuler(props: IModaleAnnulerProps): string {
  const { estEmprunteurPrimaire, estNouvelleMarge } = props;

  const key = (() => {
    if (estNouvelleMarge) {
      return estEmprunteurPrimaire ? "amc:texte-modale-SB-B1" : "amc:texte-modale-B2";
    }
    return estEmprunteurPrimaire
      ? "amc:texte-modale-annuler-changement-limite-SB-B1"
      : "amc:texte-modale-annuler-changement-limite-B2";
  })();

  return key;
}

function ModaleAnnuler(props: Readonly<IModaleAnnulerProps>) {
  let cybermetrieParams = useCybermetrieAMCContext();
  const onClickBoutonAnnuler = () => {
    CybermetriesAMC.EnvoieAnnulerDemandeAMC(cybermetrieParams);
    window.location.href = `${obtenirNavigationUrl(props.cookieParcoursAssurance.idCallback)}${props.parcours}/${
      props.cookieParcoursAssurance.langue
    }/annuler?idSouscription=${props.cookieParcoursAssurance.idSouscription}&idAssure=${
      props.cookieParcoursAssurance.idAssure
    }`;
  };

  return (
    <DsdModale
      id="dsd-modal-annuler"
      dataTestId="dsd-modal-annuler"
      show={props.modaleAnnulerOuvert}
      buttonPrimaryLabel={
        props.estNouvelleMarge
          ? i18n.t("amc:bouton-principal-modale-annuler-la-demande")
          : i18n.t("amc:bouton-principal-modale-annuler-changement-limite")
      }
      buttonSecondaryLabel={
        props.estNouvelleMarge
          ? i18n.t("amc:bouton-secondaire-modale-conserver-la-demande")
          : i18n.t("amc:bouton-secondaire-modale-annuler-changement-limite")
      }
      dsdModalSecondaryClick={props.onClickModaleAnnulerFermer}
      dsdModalPrimaryClick={onClickBoutonAnnuler}
      spanSlotTitle={
        props.estNouvelleMarge
          ? i18n.t("amc:titre-modale-annuler-la-demande")
          : i18n.t("amc:titre-modale-annuler-la-demande-changement-limite")
      }
    >
      <p>
        <span dangerouslySetInnerHTML={{ __html: i18n.t(obtenirTexteModaleAnnuler(props)) }}></span>
      </p>
    </DsdModale>
  );
}

export default ModaleAnnuler;
